import React from 'react'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import NavFullscreen from 'material-ui/svg-icons/navigation/fullscreen'
import screenfull from 'screenfull'

export default function Fullscreen(props = {}) {
	if (!screenfull.enabled) return null

	return (
		<FloatingActionButton
			className="fullscreen-button"
			mini
			onClick={() => screenfull.toggle()}
			{...props}
		>
			<NavFullscreen />
		</FloatingActionButton >
	)
}



// WEBPACK FOOTER //
// ./src/components/common/fullscreen/Fullscreen.jsx